

<template>
  <div>
    <!--  Breadcrumb Section Component-->
    <breadcrumb :breadcrumb="breadcrumb"/>
    <!--  News Details Section Component-->
    <news-details-area/>
  </div>
</template>
<script>
import Breadcrumb from "../components/Breadcrumb";
import NewsDetailsArea from "../components/news/NewsDetailsArea";

export default {
  name: 'NewsDetails',
  components: {NewsDetailsArea, Breadcrumb},
  data() {
    return {
      breadcrumb: {
        title: 'News Details',
        link: 'News Details'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/NewsDetails.vue